module.exports = __webpack_public_path__ + "assets/img/37_384.dc49f42a.jpg";